<template>
	<inertia-head title="TRC Stock Alert" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Alert</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						In Stock Alert, you'll get the jump on the market with real-time, exclusive alerts on what to do with your stocks. Whether it's adjusting your portfolio or taking advantage of a lucrative opportunity, our critical updates are time-sensitive and need to be executed right away. Unlock the power of TRC Membership today and stay ahead of the game!						
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div v-for="(stock, s_index) in stockAlerts" class="block block-rounded mb-3">
			<div class="block-content block-content-full ribbon ribbon-left ribbon-bookmark ribbon-info">
				<div class="ribbon-box">
					<span class="badge">STOCK ALERT</span>
				</div>
				<div class="mb-3 mt-4 fs-sm">{{stock.display_date_format}}</div>
				<div v-html="stock.description" class="mb-5"></div>
				<p class="m-0 mt-3 fs-sm fw-bold">STOCK AFFECTED</p>
				<span v-for="(tag,t_index) in stock.tagsArr" class="badge bg-primary me-1">{{tag}}</span>
				<div class="mt-5 pt-4 border-top">
					<div class="fs-sm"><i class="fa fa-clock me-1"></i>{{stock.display_date_format}}</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { onMounted, ref, reactive } from 'vue'
	import AuthLayout from '../../../Layouts/AuthLayout'

	export default {
		layout: AuthLayout,
		props:{
			stockAlerts: Object
		},
		setup(props){
			onMounted(() => {
				const pageContainer = document.getElementById('page-container')
				if (pageContainer.classList.contains('sidebar-o-xs'))
					pageContainer.classList.remove('sidebar-o-xs')
			})
		}
	}
</script>